module.exports = __webpack_public_path__ + "img/P20-zh.a56c973f.png";